import { useMemo } from 'react';
import { useLiveSafetyAlertCountsQuery } from '@casops/store/apis/personnelSafetyApi';

export const useLivePersonnelSafetyNotificationsApi = () => {
  const { data } = useLiveSafetyAlertCountsQuery();
  return useMemo(() => data, [data]);
};
